import { render, staticRenderFns } from "./AddVolunteer.vue?vue&type=template&id=0c90b029"
import script from "./AddVolunteer.vue?vue&type=script&lang=js"
export * from "./AddVolunteer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports